package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.common.ui.components.AutoAwesomeIconWhite
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import react.useState
import web.cssom.ClassName

internal external interface AddNewExistingTrainingPageProps : Props {
    var viewModel: AddNewTrainingViewModel
    var onCreateBasedOnPrevious: () -> Unit
    var onCreateNew: () -> Unit
}

internal val AddNewExistingTrainingPage = FC<AddNewExistingTrainingPageProps> { props ->
    var isLoading by useState(false)

    div {
        className = ClassName("wizard-page")

        div {
            className = ClassName("existing-training-card")

            div {
                className = ClassName("existing-training-icon-row")
                AutoAwesomeIconWhite {}
            }

            p {
                className = ClassName("existing-training-question")
                +"Would you like to create a new training program based on your previous program, or start fresh with a completely new one?"
            }

            div {
                className = ClassName("existing-training-actions")

                button {
                    className = ClassName(if (isLoading) "primary-button loading existing-training-btn" else "primary-button existing-training-btn")
                    disabled = isLoading
                    onClick = {
                        isLoading = true
                        props.viewModel.createTrainingProgramBasedOnPrevious {
                            props.onCreateBasedOnPrevious()
                        }
                    }
                    if (isLoading) {
                        span { className = ClassName("button-spinner") }
                    } else {
                        span { +"Based on previous" }
                    }
                }

                button {
                    className = ClassName("outlined-button existing-training-btn")
                    disabled = isLoading
                    onClick = { props.onCreateNew() }
                    +"Start fresh"
                }
            }
        }
    }
}
